module.exports = __webpack_public_path__ + "img/image.a5b273df.png";